export class Address{
    streetAddress? : string;
    city? : string;
    state? : string;
    postcode? : string;
    country? : string;
}